<template>
  <div class="share">
    <div class="_input" @click="goSelect()">
      <slot></slot>
    </div>
    <el-dialog title="分享和保存" :visible.sync="dialogVisible" width="428px">
      <div class="content">
        <div class="share-box" style="margin-bottom: 24px;">
          <div class="inline img-box">
            <img src="@/assets/images/text_code.jpg" alt />
          </div>
          <div class="inline _r">
            <el-button plain>下载二维码</el-button>
          </div>
        </div>
        <div class="_p">
          <p>订单内容</p>
        </div>
        <div style="margin-top: 7px;">
          <el-input placeholder="请输入内容" v-model="content">
            <el-button slot="append" plain>复制链接</el-button>
          </el-input>
        </div>
        <div class="_p" style="margin-top: 24px;">
          <p class="inline">是否开启名片分享</p>
          <el-switch v-model="isShare" active-color="#258EF7" style="float: right;" inactive-color="#ff4949"></el-switch>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialogVisible: false,
      content: "",
      isShare: true
    };
  },
  methods: {
    goSelect() {
      this.dialogVisible = true;
    }
  }
};
</script>
<style lang="less" scoped>
.share {
  position: relative;
  display: inline-block;
  ._input {
    display: inline-block;
    vertical-align: middle;
    width: 100%;
  }
  /deep/ .el-dialog__header {
    padding: 16px 24px;
    font-size: 16px;
    color: #252d3e;
    height: auto;
    border-bottom: 1px solid rgba(0, 0, 0, 0.09);
  }
  /deep/ .el-dialog__body {
    padding: 0;
    .content {
      padding: 24px;
      .share-box {
        line-height: 120px;
        position: relative;
        .img-box {
          width: 120px;
          height: 120px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        ._r {
          width: 260px;
          text-align: right;
        }
      }
      ._p {
        font-size: 14px;
        font-weight: 400;
        color: #475059;
        line-height: 22px;
      }
      /deep/ .el-input-group__append {
        line-height: 30px;
      }
    }
  }
}
</style>
